 /*=========================================================================================
  File Name: mutations.js
  Description: Restaurant Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Restaurant State Module
  Author: Tan Tran
==========================================================================================*/
export default {

    SET_RESTAURANT_STATE ( state, payload ) {
        //console.log('SET_RESTAURANT_STATE')
        state.restaurant.restaurantId = payload.restaurantId;  
        state.restaurant.restaurantName = payload.restaurantName;
        state.restaurant.organizationNumber = payload.organizationNumber;
        state.restaurant.description = payload.description;
        state.restaurant.homePage = payload.homePage;
        state.restaurant.restaurantType = payload.restaurantType;
        state.restaurant.postNumber = payload.postNumber;
        state.restaurant.address = payload.address;
        state.restaurant.city = payload.city;
        state.restaurant.phoneNumber = payload.phoneNumber;
        state.restaurant.imageUrl = payload.imageUrl;
        //console.log(state)
    },

}